<!-- 备货打包 -->
<template>
<el-dialog :title="msg('备货打包')" :visible.sync="visible"
    :fullscreen="isMinScreen"
    :close-on-click-modal="false" 
    :close-on-press-escape="false"
    :show-close="false"
    width="70%"
>
    <el-form ref="form" :model="stock"  label-width="100px" style="margin:0 10px">
        <!-- <el-row>
            <el-col :xs="24" :sm="24">
                <el-form-item :label="msg('打包仓库：')">
                    <el-input size="mini" v-model.trim="stockDetail.productTitle" ></el-input>
                </el-form-item>
            </el-col>
        </el-row> -->
        <el-row> 
            <el-col :xs="24" :sm="8">
                <el-form-item :label="msg('运输方式')">
                    <el-select v-model="stock.transport" placeholder="请选择" size="mini">
                        <el-option
                        v-for="item in dicts.transportType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8">
                <el-form-item :label="msg('货物性质')">
                    <el-select v-model="stock.expGoodType" placeholder="请选择" size="mini">
                        <el-option
                        v-for="item in dicts.stockExpGoodType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="8">
                <el-form-item :label="msg('配送方式')">
                    <el-select v-model="stock.expCompany" placeholder="请选择" size="mini">
                        <el-option
                        v-for="item in expCompanys"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :xs="24" :sm="24">
                <el-form-item :label="msg('报单备注：')">
                    <el-input 
                        type="textarea"
                        size="mini"
                        :rows="2"
                        maxlength="100"
                        show-word-limit
                        v-model.trim="stock.remark1" 
                        placeholder="需要分包的快递请加好说明，认真备注好打包要求，可减少打包出错概率！"
                    ></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <div class="data-row" style="margin: 0px 15px 15px 15px;">
            <table :style="{ width: '100%', minWidth: '600px'}" style="border: 1px solid #dcdfe6;">
                <tr style="height: 100px;"  v-for="(detail, i) in details" :key="i+1">
                    <td style="width: 60%; padding-top:5px;padding-left:10px;border-bottom: 1px solid #dcdfe6;">
                        <div class="item1">
                            <span style="width: 100px; min-width: 80px; height: 120px; overflow: hidden; position: relative;">
                                <el-image  style="width: 100px; min-width: 100px; height: 80px" 
                                    :src="kit.api.imgView+detail.productThumb" 
                                    :preview-src-list="[kit.api.imgView+detail.productThumb]"
                                ></el-image>
                                <span style="position: relative;cursor: pointer;top: 5px; left: 40px;color:#ff4a57"><i slot="suffix" class="el-icon-delete" @click="deleteDetail(detail)"></i></span>
                            </span>
                            <div class="product-info">
                                <div class="cell-1 product-row">
                                    <span class="product-title">{{ detail.productTitle }}<span style="padding-left:10px;">x<span style="font-size: 18px;color: #be0909 !important;padding-left:2px;">{{ detail.productQty }}</span></span></span>
                                </div>
                                <div class="cell-1">
                                    <span>商品ID：</span>
                                    <span>{{ detail.productId }}</span>
                                </div>
                                <div class="cell-1">
                                    <span>规&nbsp;&nbsp;&nbsp;&nbsp;格：</span>
                                    <span>{{ detail.productSpec }}</span>
                                </div>
                                <div class="cell-1">
                                    <span>S&nbsp;&nbsp;K&nbsp;&nbsp;U：</span>
                                    <span>{{ detail.sku }}</span>
                                </div>
                                <div class="cell-1">
                                    <span>货&nbsp;&nbsp;&nbsp;&nbsp;号：</span>
                                    <span>{{ detail.variationSku }}</span>
                                </div>
                                <div class="cell-1">
                                    <span>价&nbsp;&nbsp;&nbsp;&nbsp;格：</span>
                                    <span>{{ detail.productPrice > 0 ? (detail.productPrice / 100).toFixed(2) : ''  }}</span>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td style="width: 40%; background-color: #f3f3f3">
                        <div style="text-align: left;">
                            <el-form-item :label="msg('备货方式：')">
                                <el-radio v-model="detail.radioType" label="1">快递</el-radio>
                                <el-radio v-model="detail.radioType" label="2">库存</el-radio>
                                <el-tooltip class="item" effect="dark" content="当设置为缺货打包的时候，说明不用等待该商品到齐就直接打包出库" placement="top">
                                    <el-switch
                                        v-model="detail.mark"
                                        active-color="#13ce66"
                                        inactive-color="#c0c4cc"
                                        active-value="1"
                                        inactive-value="0"
                                        active-text="点到打包"
                                        style="left:30px;"
                                    >
                                    </el-switch>
                                </el-tooltip>
                            </el-form-item>
                            <el-form-item v-if="detail.radioType==2 && !detail.innerExpCode" label="" style="position:relative;top:-30px;">
                                <el-tag @click="searchInv(detail)" style="width:85%;cursor: pointer;color:#0052d9;text-align:center;" effect="plain"><i class="el-icon-plus"></i>选择库存</el-tag>
                            </el-form-item>
                            <el-form-item v-if="detail.radioType==null || detail.radioType==1 || detail.innerExpCode || detail.showExpCodeInput" :label="msg('备货单号：')" style="position:relative;top:-30px;">
                                <el-input size="small" v-model.trim="detail.innerExpCode" style="width: 90%;" placeholder="请填写备货单号"></el-input>
                            </el-form-item>
                            <div v-if="detail.shelfCode || detail.storeName" class="cell-2">
                                <span v-if="detail.shelfCode">架位号：{{ detail.shelfCode }}</span>
                                <span v-if="detail.storeName" :style="detail.shelfCode?'margin-left:50px;':''">仓库：{{ detail.storeName }}</span>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div style="text-align:center; margin-top: 15px;">
            <el-tag @click="addDetail()" style="width:96%;cursor: pointer;color:#0052d9" effect="plain"><i class="el-icon-plus"></i>添加额外发货信息</el-tag>
        </div>
        <div style="text-align:center; margin-top: 15px;">
            <el-button type="primary" size="mini"  @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('确定')}}</span></el-button>
            <el-button size="mini" @click="close()">{{msg('取消')}}</el-button>
        </div>
    </el-form>

    <!--添加详情-->
    <add-stock-detail-dialog ref="AddStockDetailDialogRef" @finish="getDetail()"/>

    <el-dialog :title="msg('查找库存')" :visible.sync="searchVisible" :fullscreen="isMinScreen"  @opened="openedSearch"
        :close-on-click-modal="false" append-to-body width="65%">
        <order-pkg-search :detail="searchDetail" :type="1" ref="searchDg" v-on:close-dg="closeSearch"/>
    </el-dialog>

</el-dialog>
</template>

<script>
import OrderService from "./OrderService.js"
import AddStockDetailDialog from "./AddStockDetailDialog.vue"
import OrderPkgSearch from './OrderPkgSearch.vue';
export default {
    name: "OrderPkgDialog",
    components: {
        AddStockDetailDialog,
        OrderPkgSearch
    },
    data(){
        return {
            visible: false,
            stockId:null,
            stock:{
                id:null,
                transport:null,
                expGoodType:null,
                expCompany:null,
                remark1:null,
            },
            value:null,
            radio:null,
            details:[],
            searchVisible:false,
            searchDetail:null,
            searchUseds:[],//记录已转寄的库存
            expCompanys:[],
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        }
    },
    methods: {
        showDialog(order){
            this.visible = true;
            this.getCompanys();
            console.log('order',order);
            this.details.splice(0, this.details.length);
            this.details = order.details;
            this.searchUseds = [];
            this.stockId = order.stockId;
            this.stock = {
                id : order.stockId,
                transport : order.details[0].transport,
                expGoodType : order.details[0].goodType,
                expCompany : order.details[0].expCompany,
                remark1 : order.details[0].remark1,
            }
        },
        getCompanys(){
            this.$axios.get(this.$kit.api.getExpCompany)
                .then((result)=> {
                    if(result.status){
                        this.expCompanys = result.data;
                    }
                });
        },
        //新增一条详情
        addDetail(){
            let detail = this.details[0];
            let stock = {id:detail.stockId, status: detail.status};
            this.$refs.AddStockDetailDialogRef.showDialog({
                stockId: stock.id,
                status: stock.status
            });
        },
        getDetail(){
            //重新获取详情
            var _this = this;
            let stockId = this.details[0].stockId;
            _this.$axios.get(_this.$kit.api.stockDetail.getDetailsByStockId+"?sid="+stockId
                ).then((res) => {
                    if(res.status){
                        _this.details.splice(0, _this.details.length);
                        let details = res.data;
                        _this.details = details;
                    }
            });
        },
        //删除详情
        deleteDetail(detail){
            console.log('detail',detail);
            // OrderService.deleteDetail({id: detail.id, status: detail.status}, this.getDetail);
            if(!this.hasPermission("stock:detailEdit")){
                this.$message(this.msg('无操作权限'));
                return;
            }

            let status = detail.status;
            if(status >= 13 && status <= 23){
                this.doDelete(detail);
            }else{
                if(this.hasPermission("stock:detailAddDelete")){
                    this.doDelete(detail);
                }else{
                    this.$message(this.msg('该订单不能删除'));
                }
            }
        },
        doDelete(detail){
            this.$confirm(this.msg('确定要删除详情吗？'), this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
                type: 'danger'
            }).then(() => {
                let detailId = detail.id;
                this.$axios.post(
                    this.$kit.api.stockDetail.deleteDetail+'?id='+detailId
                ).then((result)=>{
                    if(result.status){
                        this.getDetail(); //刷新
                        this.$message(result.msg || this.msg("删除成功"));
                    }else{
                        this.$message(result.msg || this.msg("删除失败"));
                    }
                });

            }).catch((err) => {
                this.$message({
                    type: 'info',
                    message: '取消'
                });
            });
        }, 
        onSubmit(){

            //开始执行保存方法
            var _this = this;

            // transport:null,
            //     expGoodType:null,
            //     expCod:null,
            //     remark1:null,
            if(!this.stock.transport && this.stock.transport != 0){
                console.log(this.stock.transport);
                this.$message(this.msg('请选择运输方式'));
                return;
            }
            if(!this.stock.expGoodType && this.stock.expGoodType != 0){
                console.log(this.stock.expGoodType);
                this.$message(this.msg('请选择货物性质'));
                return;
            }
            if(!this.stock.expCompany){
                this.$message(this.msg('请选择配送方式'));
                return;
            }
            if(!this.stock.remark1){
                this.$message(this.msg('请填写报单备注'));
                return;
            }
            //自己构建转寄信息，因为有快递和库存两种方式，为了方便全部用库存的方式传到后台
            let resends = [];
            this.details.forEach((item)=>{
                let resend = {
                    resendId: item.stockId,
                    resendDetailId:item.id,
                    resendInventoryId:item.inventoryId,
                    resendInventoryCode:item.innerExpCode,
                    shelfCode:item.shelfCode,
                    resendQty:item.productQty,
                    pkgType:item.radioType,
                    mark:item.mark,
                }
                resends.push(resend);
            });
console.log('this.stockId:',this.stockId);
            let para = {
                id: this.stockId,
                transport: this.stock.transport,
                expGoodType: this.stock.expGoodType,
                expCompany: this.stock.expCompany,
                remark1: this.stock.remark1,
                resendDtos: resends,
            }
            this.$axios.post(
                this.$kit.api.stockDetail.orderPkgSave, 
                para
            ).then(function(result){
                if(result.status){
                    _this.finish(true);
                    _this.$message(result.msg || _this.msg("更新成功"));
                }else{
                    _this.$message(result.msg || _this.msg("更新失败"));
                }
            });
        },
        //搜索库存
        searchInv(detail){
            this.searchVisible = true;
            this.searchDetail = detail;
        },
        //打开搜索弹窗之后
        openedSearch(){
            this.$nextTick(()=>{
                this.$refs.searchDg.init(this.searchUseds);
            });
        },
        //关闭搜索库存弹窗
        closeSearch(inventory, detailId){
            //关闭弹窗
            this.searchVisible = false;
            //把库存信息赋值给detail
            this.details.forEach((item)=>{
                if(item.id == detailId){
                    //给detail赋值
                    item.shelfCode = inventory.shelfCode;
                    item.storeName = inventory.storeName;
                    item.innerExpCode = inventory.code;
                    item.inventoryId = inventory.id;
                    item.showExpCodeInput = true;
                }
            });
            //把useds赋值，用于记录已转寄的库存数量，防止转寄数量不足
            if(this.searchUseds.length > 0){
                console.log('11');
                let used = this.searchUseds.find(u => u.id == inventory.id);
                console.log('used',used);
                if(used){
                    used.productQty = used.productQty+inventory.productQty;
                    console.log('22',used.productQty);
                    console.log('33',this.searchUseds);
                }else{
                    this.searchUseds.push(inventory);
                }
            }else{
                this.searchUseds.push(inventory);
            }
            console.log('44',this.searchUseds);
        },
        close(type){
            this.finish(false);
        },
        finish(type){
            // this.stockDetail.productPrice = this.stockDetail.productPrice/100;
            this.$emit("finish", {stockDetail: this.stockDetail, type: type});
            this.visible = false;
        }
    }
}
</script>
<style lang="scss" scoped>
.item1 {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    min-width: 0;
    overflow: hidden;
}
.product-info{
    flex: 1;
    min-width: 0;
    overflow: hidden;
    max-width: 100%;
}
.cell-2{
    font-size: 14px;
    color: #666;
    position: relative;
    top: -40px;
    left: 30px;
}
.cell-3{
    font-size: 14px;
    color: #333;
    margin-bottom: 8px;
}
.cell-4{
    word-wrap: break-word;
    overflow-wrap: break-word;
}
.product-qty {
    font-size: 18px;
    color: #be0909 !important;
    flex-shrink: 0 !important;
    flex-grow: 0 !important;
    min-width: 35px !important;
    max-width: 35px !important;
    width: 35px !important;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    padding: 2px 4px;
    box-sizing: border-box;
}
</style>